import { ContextProvider } from "./tag-BGPqPsHp.js";

//#region brt.ts
function BrtIgnore({ children }) {
	return children;
}
function toBunjaRenderTree(fiber) {
	const result = postCollapseContexts(traverse(fiber));
	writeNo(result);
	return result;
	function traverse(fiber$1) {
		if (fiber$1.type === BrtIgnore) return [];
		const key = fiber$1.key;
		const name = getFiberName(fiber$1);
		if (fiber$1.tag === ContextProvider) {
			const { contexts, next } = collapseContexts(fiber$1);
			const children$1 = traverseChildren(next);
			if (children$1.length === 0) return [];
			return [{
				type: "context",
				no: 0,
				key,
				name,
				contexts,
				children: children$1
			}];
		}
		const children = traverseChildren(fiber$1.child);
		if (!checkUsingBunja(fiber$1)) return children;
		return [{
			type: "component",
			no: 0,
			key,
			name,
			bunjaHooks: collectBunjaHooks(fiber$1),
			children
		}];
	}
	function traverseChildren(child) {
		const result$1 = [];
		let curr = child;
		while (curr) {
			result$1.push(...traverse(curr));
			curr = curr.sibling;
		}
		return result$1;
	}
	function collapseContexts(contextFiber) {
		const contexts = [];
		let curr = contextFiber;
		while (curr) {
			if (curr.tag === ContextProvider) {
				const context = curr.type;
				const value = curr.memoizedProps.value;
				contexts.push([context, value]);
			} else if (checkUsingBunja(curr)) break;
			curr = curr.child;
			if (curr?.sibling) break;
		}
		return {
			contexts,
			next: curr
		};
	}
	function postCollapseContexts(brt) {
		return brt.map((node) => {
			node.children = postCollapseContexts(node.children);
			if (node.type !== "context") return node;
			if (node.children.length > 1) return node;
			const child = node.children[0];
			if (child.type !== "context") return node;
			node.contexts.push(...child.contexts);
			node.children = child.children;
			return node;
		});
	}
	function writeNo(nodes, start = 1) {
		let curr = start;
		for (const node of nodes) {
			node.no = curr++;
			curr = writeNo(node.children, curr);
		}
		return curr;
	}
}
function brtToString(nodes, depth = 0) {
	const indent = " ".repeat(depth * 2);
	let result = "";
	for (const node of nodes) if (node.type === "component") {
		const { name, bunjaHooks, children } = node;
		const count = bunjaHooks.length;
		result += `${indent}<${name || "[Anonymous]"} useBunja=${count}>\n`;
		result += brtToString(children, depth + 1);
	} else if (node.type === "context") {
		const { contexts, children } = node;
		const count = contexts.length;
		if (count === 1) {
			const [context, value] = contexts[0];
			const name = context.displayName || "[Anonymous Context]";
			result += `${indent}<${name} value=${repr(value)}>\n`;
		} else result += `${indent}<Contexts count=${count}>\n`;
		result += brtToString(children, depth + 1);
	}
	return result;
}
function repr(value) {
	if (!value) return String(value);
	if (typeof value === "function") return value.name || "[Function]";
	if (typeof value === "object") return `[${Object.prototype.toString.call(value).slice(8, -1)}]`;
	if (typeof value !== "string") return String(value);
	const json = JSON.stringify(value);
	return json.length > 20 ? json.slice(0, 20) + "...\"" : json;
}
function getFiberName({ type }) {
	if (!type) return "";
	if (typeof type === "string") return type;
	return type._context?.displayName || type.displayName || type.name || "";
}
function checkUsingBunja(fiber) {
	if (!fiber.memoizedState) return false;
	let curr = fiber.memoizedState;
	while (curr) {
		if (checkBunjaMemo(curr.memoizedState)) return true;
		curr = curr.next;
	}
	return false;
}
function collectBunjaHooks(fiber) {
	const bunjaHooks = [];
	if (!fiber.memoizedState) return bunjaHooks;
	let curr = fiber.memoizedState;
	while (curr) {
		const hook = curr.memoizedState;
		if (checkBunjaMemo(hook)) bunjaHooks.push(hook[0]);
		curr = curr.next;
	}
	return bunjaHooks;
}
function checkBunjaMemo(memoizedState) {
	if (!Array.isArray(memoizedState)) return false;
	if (memoizedState.length !== 2) return false;
	return checkBunjaHookValue(memoizedState[0]);
}
function checkBunjaHookValue(memo) {
	if (typeof memo !== "object" || memo == null) return false;
	if (!("bunja" in memo)) return false;
	if (!("scopeValuePairs" in memo)) return false;
	if (!("bunjaInstance" in memo)) return false;
	return true;
}

//#endregion
export { BrtIgnore, brtToString, toBunjaRenderTree };